import React, { useEffect } from 'react';
import { Container, Row, Col, Image, Badge } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../Styles/CicalfateStyle.css";
import cicalfateHeroImage from '../Assets/cback.png';
import cicalfateApplication from '../Assets/c1.png';
import cicalfateIngredients from '../Assets/c2.png';
import cicalfateBeforeAfter from '../Assets/thermdev.png';

const CicalfatePage = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: false
    });
  }, []);
const handleOpenPDF = () => {
  // Using fetch to get the file as blob
  fetch("https://romanqadir.github.io/jsonapi/CECALFATE.pdf")
    .then(response => response.blob())
    .then(blob => {
      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'cicalfate.pdf'; // Specify the filename for download
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Download failed:', error);
      // Fallback to opening in new tab if download fails
      window.open("https://romanqadir.github.io/jsonapi/CECALFATE.pdf", '_blank');
    });
};

  // Key benefits
  const benefits = [
    {
      id: 1,
      title: "3x Faster Recovery",
      description: "Clinically proven to accelerate skin healing process",
      icon: "fas fa-bolt",
      color: "#4CAF50"
    },
    {
      id: 2,
      title: "Postbiotic Power",
      description: "Enhanced with Aquaphilus Dolomiae ferment for skin microbiome",
      icon: "fas fa-seedling",
      color: "#2196F3"
    },
    {
      id: 3,
      title: "Multi-Use Formula",
      description: "Suitable for all irritated skin types and ages",
      icon: "fas fa-users",
      color: "#FF9800"
    }
  ];

  // Skin concerns addressed
  const skinConcerns = [
    {
      concern: "Dry & Sensitive Skin",
      icon: "fas fa-tint",
      description: "Restores moisture barrier and soothes discomfort"
    },
    {
      concern: "Irritated Skin",
      icon: "fas fa-hand-holding-heart",
      description: "Calms redness and reduces inflammation"
    },
    {
      concern: "Damaged Skin Barrier",
      icon: "fas fa-shield-alt",
      description: "Repairs and protects against external aggressors"
    }
  ];

  // Key ingredients
  const keyIngredients = [
    {
      name: "Zinc Oxide",
      role: "Protective Barrier",
      benefit: "Forms occlusive layer to shield skin",
      icon: "fas fa-shield"
    },
    {
      name: "Copper + Zinc Sulfates",
      role: "Skin Environment",
      benefit: "Promote optimal healing conditions",
      icon: "fas fa-leaf"
    },
    {
      name: "Aquaphilus Dolomiae",
      role: "Postbiotic",
      benefit: "Supports skin microbiome balance",
      icon: "fas fa-bacteria"
    }
  ];

  // Usage scenarios
  const usageScenarios = [
    {
      scenario: "Post-Procedure Care",
      description: "Ideal after dermatological treatments",
      icon: "fas fa-stethoscope"
    },
    {
      scenario: "Daily Protection",
      description: "For sensitive skin exposed to environmental stress",
      icon: "fas fa-sun"
    },
    {
      scenario: "Family Care",
      description: "Safe for infants, children, and adults",
      icon: "fas fa-home"
    }
  ];

  return (
    <div className="cicalfate-product-page">
      {/* Hero Section */}
      <section className="cicalfate-hero-section">
        <Container>
          <Row className="align-items-center min-vh-80">
            <Col md={5} className="hero-content" data-aos="fade-right">
              <Badge bg="light" text="dark" className="mb-3" data-aos="fade-up">
                <i className="fas fa-award me-2"></i>
                Postbiotic-Powered Recovery
              </Badge>
              <h1 className="product-title animate-charcter-cicalfate">
                CICALFATE<sup>+</sup>
              </h1>
              <h2 className="product-subtitle">
                REPAIRING PROTECTIVE CREAM
              </h2>
              <p className="hero-tagline" data-aos="fade-up" data-aos-delay="200">
                Protective, Repairing Care for every skin
              </p>
              
              <div className="stats-badge" data-aos="fade-up" data-aos-delay="300">
                <div className="stat-number">3×</div>
                <div className="stat-label">FASTER SKIN RECOVERY*</div>
              </div>
              
              <div className="tech-badges" data-aos="fade-up" data-aos-delay="400">
                {benefits.map(benefit => (
                  <span key={benefit.id} className="tech-badge" style={{ borderColor: benefit.color }}>
                    <i className={benefit.icon} style={{ color: benefit.color }}></i>
                    {benefit.title}
                  </span>
                ))}
              </div>
            </Col>
            
            <Col md={7} className="text-center" data-aos="fade-left" data-aos-delay="200">
              <div className="product-container">
                <br></br>
                <Image 
                  src={cicalfateHeroImage} 
                  fluid 
                  className="product-hero-image cicalfate-floating" 
                  alt="Cicalfate+ Repairing Protective Cream"
                />
                <div className="healing-rings">
                  <div className="ring ring-1" style={{ borderColor: 'rgba(76, 175, 80, 0.3)' }}></div>
                  <div className="ring ring-2" style={{ borderColor: 'rgba(33, 150, 243, 0.3)' }}></div>
                  <div className="ring ring-3" style={{ borderColor: 'rgba(255, 152, 0, 0.3)' }}></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Benefits Introduction */}
      <section className="benefits-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={10} className="text-center" data-aos="fade-up">
              <div className="cicalfate-icon mb-4" data-aos="zoom-in">
                <i className="fas fa-heart"></i>
              </div>
              <h2 className="section-title cicalfate-title mb-4">
                Enhanced Formula with <span className="text-highlight">Multiple Uses</span>
              </h2>
              <p className="intro-text cicalfate-description">
                Cicalfate+ combines the protective power of Zinc Oxide with postbiotic technology 
                to create a multi-use cream that supports skin recovery, promotes a healthy skin 
                environment, and maintains proper moisture levels for optimal restoration.
              </p>
            </Col>
          </Row>
          
          {/* Benefit Cards */}
          <Row className="g-4 mt-5">
            {benefits.map((benefit, index) => (
              <Col lg={4} key={benefit.id} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="benefit-card" style={{ borderTopColor: benefit.color }}>
                  <div className="benefit-card-icon" style={{ color: benefit.color }}>
                    <i className={benefit.icon}></i>
                  </div>
                  <h4>{benefit.title}</h4>
                  <p>{benefit.description}</p>
                  <div className="benefit-wave">
                    <div className="wave" style={{ background: benefit.color }}></div>
                    <div className="wave" style={{ background: benefit.color, animationDelay: '0.2s' }}></div>
                    <div className="wave" style={{ background: benefit.color, animationDelay: '0.4s' }}></div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Skin Concerns Section */}
      <section className="concerns-section py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} data-aos="fade-right">
              <div className="application-visualization">
                <Image 
                  src={cicalfateApplication} 
                  fluid 
                  className="application-image shadow-lg" 
                  alt="Cicalfate+ Application"
                />
                <div className="application-tag" style={{ top: '20%', right: '10%' }} data-aos="fade-left">
                  <div className="tag-point" style={{ background: '#4CAF50' }}></div>
                  <span>Soothes & Calms</span>
                </div>
                <div className="application-tag" style={{ top: '50%', left: '10%' }} data-aos="fade-left" data-aos-delay="100">
                  <div className="tag-point" style={{ background: '#2196F3' }}></div>
                  <span>Protects Barrier</span>
                </div>
                <div className="application-tag" style={{ top: '80%', right: '15%' }} data-aos="fade-left" data-aos-delay="200">
                  <div className="tag-point" style={{ background: '#FF9800' }}></div>
                  <span>Accelerates Healing</span>
                </div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <h2 className="section-title cicalfate-title mb-4">
                For Every <span className="text-highlight">Skin Concern</span>
              </h2>
              <div className="divider mb-4"></div>
              
              <p className="mb-4">
                The multi-use cream formula is specifically designed to address various skin concerns 
                while being gentle enough for all ages, from infants to adults.
              </p>
              
              <div className="concerns-list">
                {skinConcerns.map((concern, index) => (
                  <div key={index} className="concern-item" data-aos="fade-up" data-aos-delay={index * 50}>
                    <div className="concern-icon">
                      <i className={concern.icon} style={{ color: '#4CAF50' }}></i>
                    </div>
                    <div className="concern-content">
                      <h5>{concern.concern}</h5>
                      <p>{concern.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Key Ingredients */}
      <section className="ingredients-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title cicalfate-title" data-aos="fade-up">
                Science-Backed <span className="text-highlight">Ingredients</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
              <p className="lead" data-aos="fade-up" data-aos-delay="200">
                Formulated with clinically-proven active ingredients
              </p>
            </Col>
          </Row>
          
          <Row className="g-4 align-items-center mb-5">
            <Col lg={6} data-aos="fade-right">
              <div className="ingredients-display">
                <Image 
                  src={cicalfateIngredients} 
                  fluid 
                  className="ingredients-image floating-rotate" 
                  alt="Cicalfate+ Key Ingredients"
                />
                <div className="ingredients-glow"></div>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left">
              <div className="ingredients-info">
                <h3 className="mb-4">Active Ingredients Breakdown</h3>
                
                {keyIngredients.map((ingredient, index) => (
                  <div key={index} className="ingredient-card mb-4">
                    <div className="ingredient-header">
                      <div className="ingredient-icon">
                        <i className={ingredient.icon}></i>
                      </div>
                      <div>
                        <h4>{ingredient.name}</h4>
                        <Badge bg="info" className="ms-2">{ingredient.role}</Badge>
                      </div>
                    </div>
                    
                    <div className="ingredient-details mt-3">
                      <p><strong>Benefit:</strong> {ingredient.benefit}</p>
                    </div>
                  </div>
                ))}
                
                <div className="safety-badge mt-4" data-aos="fade-up">
                  <i className="fas fa-check-circle me-2"></i>
                  <span>Safe for use on skin and external mucosae</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Usage Scenarios */}
      <section className="usage-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title cicalfate-title" data-aos="fade-up">
                Multi-Use <span className="text-highlight">Applications</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            {usageScenarios.map((scenario, index) => (
              <Col md={4} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="usage-card">
                  <div className="usage-icon">
                    <i className={scenario.icon}></i>
                  </div>
                  <h4>{scenario.scenario}</h4>
                  <p>{scenario.description}</p>
                  <div className="usage-wave">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          
          {/* <Row className="mt-5">
            <Col lg={12} data-aos="fade-up">
              <div className="results-display">
                <Image 
                  src={cicalfateBeforeAfter} 
                  fluid 
                  className="results-image rounded-lg shadow" 
                  alt="Cicalfate+ Results"
                />
                <div className="results-overlay">
                  <div className="results-info" data-aos="fade-left">
                    <h5>Visible Improvement</h5>
                    <p>Clinical studies show significant improvement in skin barrier function</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row> */}
        </Container>
      </section>

      {/* Tolerance & Safety */}
      <section className="tolerance-section py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title cicalfate-title" data-aos="fade-up">
                Maximum <span className="text-highlight">Tolerance & Safety</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            <Col lg={4} data-aos="fade-up">
              <div className="tolerance-card">
                <div className="tolerance-icon">
                  <i className="fas fa-baby"></i>
                </div>
                <h4>Suitable for Infants</h4>
                <p>Gentle enough for delicate infant skin</p>
              </div>
            </Col>
            
            <Col lg={4} data-aos="fade-up" data-aos-delay="100">
              <div className="tolerance-card">
                <div className="tolerance-icon">
                  <i className="fas fa-child"></i>
                </div>
                <h4>Safe for Children</h4>
                <p>Non-irritating formula for young skin</p>
              </div>
            </Col>
            
            <Col lg={4} data-aos="fade-up" data-aos-delay="200">
              <div className="tolerance-card">
                <div className="tolerance-icon">
                  <i className="fas fa-user"></i>
                </div>
                <h4>All Adult Skin Types</h4>
                <p>Effective for sensitive, dry, and irritated skin</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Download Section */}
      <section className="cicalfate-catalog-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center" data-aos="fade-up">
              <h2 className="section-title cicalfate-title mb-4">
                Download <span className="text-highlight">Complete Product Information</span>
              </h2>
              <p className="lead mb-5">
                Product specifications, clinical studies, and usage guidelines
              </p>
              
              <div className="catalog-preview mb-5" data-aos="zoom-in">
                <div className="catalog-frame cicalfate-catalog">
                  <div className="catalog-3d">
                    <div className="catalog-front">
                      <h3>CICALFATE<sup>+</sup></h3>
                      <p>Repairing Protective Cream</p>
                      <div className="tech-tags">
                        <span>Postbiotic-Powered</span>
                        <span>3x Faster Recovery</span>
                        <span>Multi-Use</span>
                      </div>
                    </div>
                    <div className="catalog-side"></div>
                  </div>
                  <div className="catalog-overlay" onClick={handleOpenPDF}>
                    <span className="overlay-text">View Full Product Details</span>
                  </div>
                </div>
              </div>
              
              <button 
                onClick={handleOpenPDF}
                className="btn btn-primary btn-lg download-btn pulse"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <i className="fas fa-download me-2"></i> Download Product PDF
              </button>
              
              <p className="mt-3 text-muted" data-aos="fade-up" data-aos-delay="300">
                <small>Includes full ingredient list and clinical data</small>
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Epilyum Brand Section */}
      <section className="brand-section py-4">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <div className="brand-alert" data-aos="fade-up">
                <div className="brand-icon">
                  <i className="fas fa-leaf"></i>
                </div>
                <div className="brand-content">
                  <h5>EPILYUM - Discover the Convenience</h5>
                  <p>
                    Cicalfate+ is part of the Epilyum skincare family, dedicated to providing 
                    innovative, science-backed solutions for skin recovery and protection.
                  </p>
                  <a href="https://www.epilyum.com" className="brand-link">
                    www.epilyum.com
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default CicalfatePage;